import React, { FormEvent, useContext, useState, Fragment } from "react";
import { observer } from "mobx-react-lite";
import TransmissionStore from "../../../app/stores/transmissionStore";
import { IProjectVendor } from "../../../app/models/projectvendor";
import {
  Button,
  Card,
  Form,
  Grid,
  Input,
  Select,
  Tab,
  Table,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
const SiteAccessTab = () => {
  const {
    transmission,
    submitting,
    createProjectVendor,
    loadProjectVendors,
    projectvendorsByName,
    editProjectVendor,
    deleteProjectVendor,
  } = useContext(TransmissionStore);

  const initialForm: IProjectVendor = {
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: transmission!.id,
    type: "Access",
    companyName: "",
    status: "",
    attachment: "",
    remark: "",
    phone: "",
    email: "",
  };

  const [projectVendor, setProjectVendor] = useState<IProjectVendor>({
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: transmission!.id,
    type: "Access",
    companyName: "",
    status: "",
    attachment: "",
    remark: "",
    phone: "",
    email: "",
  });
  const vendor =
    projectvendorsByName.length > 0 ? projectvendorsByName[0] : null;

  const [edit, setEdit] = useState(false);

  const status = [
    { key: "In Progress", text: "In Progress", value: "In Progress" },
    {
      key: "Access Approved",
      text: "Access Approved",
      value: "Access Approved",
    },
  ];

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProjectVendor({ ...projectVendor, [name]: value });
  };

  const handleSubmit = () => {
    createProjectVendor(projectVendor)
      .then(() => loadProjectVendors(projectVendor.projectId))
      .then(() => initialForm && setProjectVendor(initialForm));
  };

  const handleEditSubmit = () => {
    editProjectVendor(projectVendor)
      .then(() => loadProjectVendors(projectVendor.projectId))
      .then(() => initialForm && setProjectVendor(initialForm))
      .then(() => setEdit(false));
  };

  return (
    <Tab.Pane>
      <Card fluid>
        <Card.Content>
          <Card.Header>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Site
            ID:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            <Link to={`/projectmanagement/sitevodafone/${transmission!.customerId}`} style={{ color: "blue" }}>{transmission!.projectSite.siteId}</Link>
          </Card.Header>
          <Table definition>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>Site Name</Table.Cell>
                <Table.Cell> {transmission!.projectSite.siteName} </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>Address</Table.Cell>
                <Table.Cell> {transmission!.projectSite.address} </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>Structure Type</Table.Cell>
                <Table.Cell>
                  {" "}
                  {transmission!.projectSite.structureType}{" "}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>Site Remark</Table.Cell>
                <Table.Cell> {transmission!.projectSite.remark} </Table.Cell>
              </Table.Row>
              {vendor && (
                <Fragment>
                  <Table.Row>
                    <Table.Cell collapsing>Site Status</Table.Cell>
                    <Table.Cell> {vendor!.status} </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell collapsing>Contact Person</Table.Cell>
                    <Table.Cell> {vendor!.companyName} </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell collapsing>Contact Number</Table.Cell>
                    <Table.Cell> {vendor!.phone} </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell collapsing>Contact Email</Table.Cell>
                    <Table.Cell> {vendor!.email} </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell collapsing>Contact Remark</Table.Cell>
                    <Table.Cell> {vendor!.remark} </Table.Cell>
                  </Table.Row>
                </Fragment>
              )}
            </Table.Body>
          </Table>
        </Card.Content>
      </Card>
      {vendor === null ? (
        <Grid>
          <Grid.Column width={16}>
            <Form onSubmit={handleSubmit}>
              <Form.Group>
                <Form.Field inline>
                  <label>Status</label>
                  <Select
                    required
                    onChange={(e, { name, value }) => {
                      setProjectVendor({ ...projectVendor, [name]: value });
                    }}
                    options={status}
                    search
                    name="status"
                    placeholder="Status"
                  />
                </Form.Field>
                <Form.Field inline>
                  <label>Contact Person</label>
                  <Input
                    onChange={handleInputChange}
                    name="companyName"
                    placeholder="Contact Person"
                    value={projectVendor.companyName}
                  />
                </Form.Field>
                <Form.Field inline>
                  <label>Contact Number</label>
                  <Input
                    onChange={handleInputChange}
                    name="phone"
                    placeholder="Contact Number"
                    value={projectVendor.phone}
                  />
                </Form.Field>
                <Form.Field inline>
                  <label>Contact Email</label>
                  <Input
                    onChange={handleInputChange}
                    name="email"
                    placeholder="Contact Email"
                    value={projectVendor.email}
                  />
                </Form.Field>
                <Form.Field inline>
                  <label>Remark</label>
                  <Input
                    onChange={handleInputChange}
                    name="remark"
                    placeholder="Remark"
                    value={projectVendor.remark}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Button
                loading={submitting}
                floated="right"
                positive
                type="submit"
                content="Add"
              />
            </Form>
          </Grid.Column>
        </Grid>
      ) : (
        <Fragment>
          <Button
            onClick={() => {
              setEdit(true);
              setProjectVendor(vendor);
            }}
          >
            Edit Contact
          </Button>
          <Button
            name={vendor.id}
            loading={vendor.id && submitting}
            onClick={(e) => deleteProjectVendor(e, vendor.id)}
            content="Delete Contact"
            color="red"
          />
        </Fragment>
      )}

      {vendor && edit && (
        <Grid>
          <Grid.Column width={16}>
            <Form onSubmit={handleEditSubmit}>
              <Form.Group>
                <Form.Field inline>
                  <label>Status</label>
                  <Select
                    required
                    onChange={(e, { name, value }) => {
                      setProjectVendor({ ...projectVendor, [name]: value });
                    }}
                    options={status}
                    search
                    name="status"
                    placeholder="Status"
                  />
                </Form.Field>
                <Form.Field inline>
                  <label>Contact Person</label>
                  <Input
                    onChange={handleInputChange}
                    name="companyName"
                    placeholder="Contact Person"
                    value={projectVendor.companyName}
                  />
                </Form.Field>
                <Form.Field inline>
                  <label>Contact Number</label>
                  <Input
                    onChange={handleInputChange}
                    name="phone"
                    placeholder="Contact Number"
                    value={projectVendor.phone}
                  />
                </Form.Field>
                <Form.Field inline>
                  <label>Contact Email</label>
                  <Input
                    onChange={handleInputChange}
                    name="email"
                    placeholder="Contact Email"
                    value={projectVendor.email}
                  />
                </Form.Field>
                <Form.Field inline>
                  <label>Remark</label>
                  <Input
                    onChange={handleInputChange}
                    name="remark"
                    placeholder="Remark"
                    value={projectVendor.remark}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Button
                loading={submitting}
                floated="right"
                positive
                type="submit"
                content="Submit"
              />
            </Form>
          </Grid.Column>
        </Grid>
      )}
    </Tab.Pane>
  );
};

export default observer(SiteAccessTab);
